import axios from "axios";
import { Toast } from "vant";
import qs from "qs";

// axios.defaults.baseURL = "http://192.168.0.110:20004/api/"; //10
// axios.defaults.baseURL = "http://naqvote.itlic.com/"; //线上
axios.defaults.baseURL = "/api"; //线上
// axios.defaults.baseURL = "http://192.168.0.160:20052/api/"; //测试

export default {
    post(url, data) {
        return axios({
            method: "post",
            url,
            timeout: 1000 * 30,
            data: data,
            headers: {
                Authorization: sessionStorage.getItem('Authorization') || ''
            }
        })
            .then(res => {
                if (res.data.code == 200) {
                    return res.data;
                } else {
                    return Promise.reject(res);
                }
            })
            .catch(res => {
                let str = JSON.parse(JSON.stringify(res));
                if (str.message || str.data.message) {
                    let errorMsg = str.message || str.data.message;
                    Toast.fail(errorMsg);
                } else {
                    Toast.fail("服务器出错了，请稍后重试！");
                }
                return Promise.reject(res.data);
            });
    },
    postImg(url, data) {
        return axios({
            method: "post",
            url,
            timeout: 1000 * 30,
            data: data,
            headers: {
                "content-type": "multipart/form-data",
                Authorization: sessionStorage.getItem('Authorization') || ''
            }
        })
            .then(res => {
                if (res.data.code == 200) {
                    return res.data;
                } else {
                    return Promise.reject(res);
                }
            })
            .catch(res => {
                let str = JSON.parse(JSON.stringify(res));
                if (str.message || str.data.message) {
                    let errorMsg = str.message || str.data.message;
                    Toast.fail(errorMsg);
                } else {
                    Toast.fail("服务器出错了，请稍后重试！");
                }
                return Promise.reject(res.data);
            });
    },
    get(url, params) {
        return axios({
            method: "get",
            url,
            timeout: 1000 * 30,
            params, // get 请求时带的参数
            headers: {
                Authorization: sessionStorage.getItem('Authorization') || ''
            }
        })
            .then(res => {
                if (res.data.code == 200) {
                    return res.data;
                } else {
                    return Promise.reject(res);
                }
            })
            .catch(res => {
                let str = JSON.parse(JSON.stringify(res));
                if (str.message || str.data.message) {
                    let errorMsg = str.message || str.data.message;
                    Toast.fail(errorMsg);
                } else {
                    Toast.fail("服务器出错了，请稍后重试！");
                }
                return Promise.reject(res.data);
            });
    }
};
